import getEnv from "@de-common/env/getEnv";
import { Environ } from "@de-common/types/Environ";

const isTest = (): boolean => {
  return getEnv() === Environ.TEST;
};

export default isTest;
